export const INITIAL_SMART_CURSOR_CONTEXT = {
  position: { x: 0, y: 0 },
  cursorType: 'default',
  setCursorType: () => {},
  cursorComponent: null,
  setCursorComponent: () => {},
  hoverTarget: null,
  setHoverTarget: () => {},
  resetCursor: () => {},
};
